import { classNames } from '@ember-decorators/component';
import Super from 'ember-simplepractice/components/shared/toggle-switch';
import styles from './toggle-switch.module.scss';

@classNames(styles.component)
export default class SharedToggleSwitch extends Super {}
